<template>
	<script type="text/x-template" id="template-printer-lights" class="template">
		<li class="block edit_block printer-lights-block adjustment-block">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">Printer Lights</label>
		    </div>

		    <div class="block_options">
		        <div class="block-controls-container" data-control="sliders" style="display: block">
		            <div class="control-container sliders-style --offset">
		                <div class="lines-container">
		                    <span class="line --printer-lights"></span>
		                    <span class="line --printer-lights"></span>
		                    <span class="line --printer-lights"></span>
		                </div>

		                <div class="slider-control --Y" data-curve="offset-Y" data-pass-index="0"></div>
		                <div class="slider-control --R" data-curve="offset-R" data-pass-index="1"></div>
		                <div class="slider-control --G" data-curve="offset-G" data-pass-index="1"></div>
		                <div class="slider-control --B" data-curve="offset-B" data-pass-index="1"></div>

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="0" data-curve="offset-Y"></input>
							<label for="offset-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-R" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="1" data-curve="offset-R"></input>
							<label for="offset-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-G" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="1" data-curve="offset-G"></input>
							<label for="offset-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-B" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="1" data-curve="offset-B"></input>
							<label for="offset-B" class="slider-control-label">B</label>
						</div>
		            </div>
		        </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
